// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-error {
  color: var(--color-text);
  overflow: auto;
  -webkit-user-select: none;
          user-select: none;
}
.page-error .error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 2vw;
}
.page-error .error-container .container-title {
  font-family: Ubuntu-R, sans-serif;
  font-size: 14vw;
  border: 1px solid #313131;
  border-radius: 20px;
  padding: 0px 24px;
}
.page-error .error-container .container-title svg {
  font-size: 8vw;
  color: var(--color-featureColor);
}
.page-error .error-container .container-subTitle {
  font-family: Ubuntu-M, sans-serif;
  font-size: 3.5vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/error/error.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AADJ;AAGI;EACE,iCAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AADN;AAGM;EACE,cAAA;EACA,gCAAA;AADR;AAKI;EACE,iCAAA;EACA,gBAAA;AAHN","sourcesContent":["@import '../../theme/scrollbar.scss';\n\n.page-error {\n  color: var(--color-text);\n  overflow: auto;\n  user-select: none;\n\n  .error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    flex-direction: column;\n    gap: 2vw;\n\n    .container-title {\n      font-family: Ubuntu-R, sans-serif;\n      font-size: 14vw;\n      border: 1px solid #313131;\n      border-radius: 20px;\n      padding: 0px 24px;\n\n      svg {\n        font-size: 8vw;\n        color: var(--color-featureColor);\n      }\n    }\n\n    .container-subTitle {\n      font-family: Ubuntu-M, sans-serif;\n      font-size: 3.5vw;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
